import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-black border-y border-navy-border" data-id="element-101" data-mp="1o2vhoq8r8p73">
      <div className="max-w-4xl mx-auto" data-id="element-102" data-mp="223oddeaslqbs">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-navy-card to-black border border-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-103" data-mp="222mzz36b0rqw">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold-gradient" data-id="element-104" data-mp="14gfp5bjeq363" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold/10 text-gold mb-8" data-id="element-105" data-mp="1j4twnzrrqfsz"><ShieldCheck size={48} data-id="element-106" data-mp="1ecsq8uha7jav" /></div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-107" data-mp="1ebr49uyq9ced">🛡️ Complete 7-Day Money-Back Guarantee</h2>
          <div className="space-y-6 text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-108" data-mp="lp6cwui950at">
            <p data-id="element-109" data-mp="ln2bcj7tsddp">Open all 6 resources. Explore every strategic resource. Use the material in your most challenging class this week.</p>
            <p className="font-medium text-white" data-id="element-110" data-mp="tycs4lahthtj">If you feel the material is not clear, practical or useful for your teaching needs — contact us within 7 days.</p>
            <p className="text-gold-light font-bold text-xl" data-id="element-111" data-mp="yrfmgvn3gvas">We will refund 100% of your money. No questions. No forms. No complications.</p>
            <p className="text-sm text-gray-400 mt-8" data-id="element-112" data-mp="61700rlizoqe">Because if the material does not deliver the value we promise, we do not want to keep your money.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}